import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectCantTiempoRecordatorio = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti,
    tiempo = 'm'
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const [dynamicOptions, setDynamicOptions] = useState([]);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const generateOptions = (type) => {
        let range = [];
        switch (type) {
            case 'm':
                range = Array.from({ length: 59 }, (_, i) => ({
                    value: i + 1,
                    label: `${i + 1}`
                }));
                break;
            case 'h':
                range = Array.from({ length: 23 }, (_, i) => ({
                    value: i + 1,
                    label: `${i + 1}`
                }));
                break;
            case 'd':
                range = Array.from({ length: 5 }, (_, i) => ({
                    value: i + 1,
                    label: `${i + 1}`
                }));
                break;
            default:
                range = [];
        }
        return range;
    };
    useEffect(() => {
        if (tiempo) {
            const newOptions = generateOptions(tiempo);
            setDynamicOptions(newOptions);
        } else {
            setDynamicOptions([]);
        }
    }, [tiempo]);
    useEffect(() => {
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(dynamicOptions.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = dynamicOptions.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff')
                : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: state.isSelected 
                    ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                    : (isDarkMode ? '#3d4a62' : '#02378c'),
                color: state.isSelected 
                    ? (isDarkMode ? '#90caf9' : '#fff')
                    : (isDarkMode ? '#e0e0e0' : '#e0e0e0'),
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                borderColor: isDarkMode ? '#64B5F6' : '#0364ff'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray'
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        })
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={dynamicOptions}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectCantTiempoRecordatorio.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectCantTiempoRecordatorio;